var _circle, _circle2, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayBtn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 164,
    height: 164,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 82,
    cy: 82,
    r: 81,
    fill: "#000",
    fillOpacity: 0.01,
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 30,
    y: 30,
    width: 104,
    height: 104
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      height: "100%",
      width: "100%"
    },
    clipPath: "url(#playBtn_svg__bgblur_0_240_2351_clip_path)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 4,
    cx: 82,
    cy: 82,
    r: 47,
    fill: "#000",
    fillOpacity: 0.01,
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.429 94.228a2.605 2.605 0 001.44 2.286 2.835 2.835 0 002.788 0L95.43 84.286a2.537 2.537 0 000-4.572L75.657 67.577a2.835 2.835 0 00-2.788 0 2.605 2.605 0 00-1.44 2.286v24.365z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "playBtn_svg__bgblur_0_240_2351_clip_path",
    transform: "translate(-30 -30)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 82,
    r: 47
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNjQiIGhlaWdodD0iMTY0IiB2aWV3Qm94PSIwIDAgMTY0IDE2NCIgZmlsbD0ibm9uZSI+CiAgICA8Y2lyY2xlIG9wYWNpdHk9IjAuNSIgY3g9IjgyIiBjeT0iODIiIHI9IjgxIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjAxIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4KICAgIDxmb3JlaWduT2JqZWN0IHg9IjMwIiB5PSIzMCIgd2lkdGg9IjEwNCIgaGVpZ2h0PSIxMDQiPjxkaXYgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGh0bWwiIHN0eWxlPSJiYWNrZHJvcC1maWx0ZXI6Ymx1cigycHgpO2NsaXAtcGF0aDp1cmwoI2JnYmx1cl8wXzI0MF8yMzUxX2NsaXBfcGF0aCk7aGVpZ2h0OjEwMCU7d2lkdGg6MTAwJSI+PC9kaXY+PC9mb3JlaWduT2JqZWN0PjxjaXJjbGUgZGF0YS1maWdtYS1iZy1ibHVyLXJhZGl1cz0iNCIgY3g9IjgyIiBjeT0iODIiIHI9IjQ3IiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjAxIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4KICAgIDxwYXRoIGQ9Ik03MS40Mjg3IDk0LjIyODVDNzEuNDM2OSA5NC43MDQ4IDcxLjU3NTUgOTUuMTY5NiA3MS44Mjk0IDk1LjU3MjZDNzIuMDgzMiA5NS45NzU2IDcyLjQ0MjcgOTYuMzAxMyA3Mi44Njg3IDk2LjUxNDNDNzMuMjk0MSA5Ni43NTQ2IDczLjc3NDQgOTYuODgwOSA3NC4yNjMgOTYuODgwOUM3NC43NTE2IDk2Ljg4MDkgNzUuMjMxOSA5Ni43NTQ2IDc1LjY1NzMgOTYuNTE0M0w5NS40Mjg3IDg0LjI4NTdDOTUuODU4OSA4NC4wNzg0IDk2LjIyMTkgODMuNzU0IDk2LjQ3NTkgODMuMzQ5NkM5Ni43Mjk5IDgyLjk0NTMgOTYuODY0NyA4Mi40Nzc1IDk2Ljg2NDcgODJDOTYuODY0NyA4MS41MjI1IDk2LjcyOTkgODEuMDU0NiA5Ni40NzU5IDgwLjY1MDNDOTYuMjIxOSA4MC4yNDYgOTUuODU4OSA3OS45MjE1IDk1LjQyODcgNzkuNzE0M0w3NS42NTczIDY3LjU3NzFDNzUuMjMxOSA2Ny4zMzY4IDc0Ljc1MTYgNjcuMjEwNCA3NC4yNjMgNjcuMjEwNEM3My43NzQ0IDY3LjIxMDQgNzMuMjk0MSA2Ny4zMzY4IDcyLjg2ODcgNjcuNTc3MUM3Mi40NDI3IDY3Ljc5MDEgNzIuMDgzMiA2OC4xMTU4IDcxLjgyOTQgNjguNTE4OEM3MS41NzU1IDY4LjkyMTggNzEuNDM2OSA2OS4zODY2IDcxLjQyODcgNjkuODYyOFY5NC4yMjg1WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICAgIDxkZWZzPgogICAgICAgIDxjbGlwUGF0aCBpZD0iYmdibHVyXzBfMjQwXzIzNTFfY2xpcF9wYXRoIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzAgLTMwKSI+PGNpcmNsZSBjeD0iODIiIGN5PSI4MiIgcj0iNDciLz4KICAgICAgICA8L2NsaXBQYXRoPjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgPlayBtn as ReactComponent };